import {useModal} from "../../../../hooks";
import {useUser} from "../../../../util/userContext/UserContext";
import {useCreateOutgoingCode} from "./hooks/useCreateOutgoingBarcode";
import {useCreateOutgoing} from "./hooks/useCreateOutgoing";
import {useUploadOutgoingExcel} from "./hooks/useUploadOutgoingExcel";
import React, {useEffect, useState} from "react";
import {OutgoingCreateType} from "./interface";
import {outgoingCreateInit} from "./state";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import ScanBarcodeInner from "../../../../components/common/modal/inner/ScanBarcodeInner";
import SearchInventoryInner from "../../../../components/common/modal/inner/SearchInventoryInner";
import moment from "moment/moment";
import FileUploadNoText from "../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import EmptyTableRow from "../../../common/EmptyTableRow";
import {InvDetailType} from "../../inv/detail/interface";
import {useLocation} from "react-router-dom";
import {SearchErpInner} from "../../../../components/common/modal/inner/SearchErpInner";
import InputNumberUc from "../../../../components/common/number/InputNumberUc";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";

export default function OutgoingCreate() {
    const {handleModal} = useModal();
    const {state} = useLocation() as { state: { invDetail: InvDetailType } };
    const invDetail = state?.invDetail;

    const {user} = useUser();
    const {data: outgoingCode} = useCreateOutgoingCode()
    const {mutate: mutateCreateOutgoing} = useCreateOutgoing()
    const {mutateAsync: mutateAsyncUploadOutgoingExcel} = useUploadOutgoingExcel()

    const [createData, setCreateData] = useState<OutgoingCreateType>((() => ({
        ...outgoingCreateInit,
        changeAt: moment().format("YYYY-MM-DD"),
    }))())

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: createData,
    });

    const watchCreateData = {
        ...createData,
        ...useWatch<OutgoingCreateType>({control}),
    };

    useEffect(() => {
        console.log("invDetail : ", invDetail);
        console.log("createData : ", createData);

        if (invDetail) {
            setValue("createEachOutgoingReqList", [{
                ...invDetail,
                changeAmount: 1,
            }]);
        }
    }, []);

    const onSubmit: SubmitHandler<OutgoingCreateType> = (submitData) => {
        if (getValues("createEachOutgoingReqList").length === 0) {
            handleModal({
                isOpen: true,
                contents: "출고 품목을 추가해주세요.",
                type: "alert"
            })
        } else {
            mutateCreateOutgoing({...submitData, code: outgoingCode})
        }
    };

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadOutgoingExcel(fd).then((res: any) => {
                if (res.data.code === "0000") {
                    const list = res.data.result

                    if (
                        getValues("createEachOutgoingReqList").some(el => list.map((el2: any) => el2.inventoryId).includes(el.inventoryId))
                    ) {
                        handleModal({
                            isOpen: true,
                            contents: "중복된 품목은 추가할 수 없습니다.",
                            type: "alert",
                        });
                    } else {
                        setValue("createEachOutgoingReqList", [...getValues("createEachOutgoingReqList"), ...list.map((el: any) => ({
                            ...el,
                        }))])
                    }
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.message ?? res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    }

    const btnShowScanBarcodeInterface = () => {
        handleModal({
            isOpen: true,
            contents: <ScanBarcodeInner
                value={getValues("createEachOutgoingReqList")}
                setValue={(data) => setValue("createEachOutgoingReqList", data)}
            />,
            type: "",
            title: "바코드 스캔"
        });
    }

    const btnAdd = () => {
        handleModal({
            isOpen: true,
            contents: <SearchInventoryInner
                confirmCallback={(item) => {
                    setValue("createEachOutgoingReqList", [...getValues("createEachOutgoingReqList"), {
                        ...item,
                        changeAmount: 1
                    }])
                }}
                modalDepth={1}
            />,
            type: "",
            title: "재고 조회",
            modalSize: "xl",
        });
    }

    const btnSearchAccountName = () => {
        handleModal({
            isOpen: true,
            contents: (
                /*
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        if (setValue) {
                            setValue("accountName", item?.name, {
                                shouldDirty: true,
                            });
                        }
                    }}
                    modalDepth={1}
                />
                * */
                <SearchErpInner
                    confirmCallback={(item) => {
                        if (setValue) {
                            setValue("accountName", item?.new_txt_nm_partner, {
                                shouldDirty: true,
                            });
                        }
                        console.log("item : ", item);
                    }}
                    modalDepth={1}
                />
            ), type: "",
            title: "출고처 조회",
            modalSize: "xl",
        });
    }

    const removeItem = (index: number) => {
        setValue("createEachOutgoingReqList", getValues("createEachOutgoingReqList").filter((_, i) => i !== index));
    };

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">출고 등록</h3>
            <div className="filter_toolbar">
                {/* NOTE: 목록 버튼이 필요 없어 보여서 삭제 */}
                {/*<button className="btn btn-outline-primary w-100px h-38px">*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록*/}
                {/*</button>*/}
                <button className="btn btn-primary w-100px h-38px" onClick={handleSubmit(onSubmit)}>등록</button>
            </div>
        </div>

        <h5 className="subheading">출고 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>출고번호</th>
                <td colSpan={3}>{outgoingCode ?? ""}</td>
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "33.3%"}}>{user?.userName ?? ""}</td>
                <th style={{width: "16.66%"}}>생성일자</th>
                <td>{moment().format("YYYY-MM-DD")}</td>
            </tr>
            <tr>
                <th>출고처</th>
                <td className="p-4px">
                    <div className="d-flex">
                        <input type="text" className="form-control"
                               value={watchCreateData.accountName ?? ''}
                               {...register("accountName")}
                               disabled={true}
                        />
                        <button
                            className="btn btn-info btn_search w-100px ms-5px"
                            onClick={btnSearchAccountName}>
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                alt=""
                            />찾기
                        </button>
                    </div>
                </td>
                <th>출고일자</th>
                <td className="p-4px">
                    <input
                        type="date"
                        className="form-control"
                        max="9999-12-31"
                        value={watchCreateData.changeAt}
                        {...register("changeAt")}
                    />
                </td>
            </tr>
            <tr>
                <th>메모</th>
                <td className="p-4px" colSpan={3}>
                    <input type="text" className="form-control"
                           value={watchCreateData.memo}
                           {...register("memo")}
                    />
                </td>
            </tr>
            </tbody>
        </table>
        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">출고 품목</h6>
            <div className="table_toolbar">
                <FileUploadNoText
                    addFileCallback={(file: File[]) => btnImportExcel(file)}
                    customRenderer={(onClick: any, disabled: any) =>
                        <button className="btn btn-outline-dark w-150px px-0"
                                onClick={onClick}
                                disabled={disabled}><img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                        </button>

                    }
                    accept={".xlsx, .xls"}
                />
                <button className="btn btn-primary w-100px px-0 ms-40px" onClick={btnShowScanBarcodeInterface}>바코드 스캔
                </button>
                <button className="btn btn-dark w-100px" onClick={btnAdd}>추가</button>
            </div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th style={{width: "5%"}}></th>
                <th style={{width: "10.06%"}}>벤더</th>
                <th style={{width: "10.06%"}}>카테고리</th>
                <th style={{width: "24.5%"}}>품목</th>
                <th style={{width: "13.83%"}}>규격</th>
                <th style={{width: "13.83%"}}>단위</th>
                <th style={{width: "13.83%"}}>출고 수량</th>
                <th>현재재고</th>
            </tr>
            </thead>
            <tbody>
            {watchCreateData.createEachOutgoingReqList.length !== 0
                ? watchCreateData.createEachOutgoingReqList.map((el, idx) =>
                    <tr>
                        <td className="text-center">
                            <button className="btn btn-link p-0" onClick={() => removeItem(idx)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"}
                                     alt=""/>
                            </button>
                        </td>
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.inventoryUnit}</td>
                        <td className="p-4px">
                            <InputNumberUc control={control} name={`createEachOutgoingReqList.${idx}.changeAmount`}/>
                            {/*<input type="text"
                                   className="form-control text-center"
                                   value={el.changeAmount}
                                   {...register(`createEachOutgoingReqList.${idx}.changeAmount`)}
                            />*/}
                        </td>
                        <td className="text-center"><DisplayNumber value={el.inventoryAmount ?? 0}/></td>
                    </tr>
                ) : <EmptyTableRow colSpan={7} msg={"출고 품목을 추가해주세요."}/>}
            <tr className="blue">
                <td className="text-center" colSpan={5}>품목 수</td>
                <td className="text-end">{watchCreateData.createEachOutgoingReqList.length}</td>
                <td className="text-center">총 수량</td>
                <td className="text-center">
                    {isNaN(watchCreateData.createEachOutgoingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0))
                        ? <>+</>
                        : <span
                            className={watchCreateData.createEachOutgoingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) < 0 ? "requiredBlue" : "required"}>
                        {watchCreateData.createEachOutgoingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) > 0 && <>-</>}
                            <DisplayNumber
                                value={watchCreateData.createEachOutgoingReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0)}/>
                    </span>
                    }
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}